import loadable from '@loadable/component';

export const SalaryExplorePageLoadable = loadable(
  () => import('./SalaryExplorePage'),
  { resolveComponent: (module) => module.SalaryExplorePage },
);
